import { normalizeHelper } from '../../utils/asyncHelpers';
import {
  createAsyncPagingAction,
  createAsyncActionStoreWrapper,
} from '../../utils/asyncPagingHelpers';
import { CONSUMPTION_POINT_LIST_FETCH } from '../../constants/consumptionPointListActionTypes';
import { consumptionPointListSearch } from '../actionHelpers/endpoints';
import consumptionPointSchema from '../../schemas/consumptionPoint';
import { getConsumptionPointList } from '../../reducers/consumptionPointListReducer';
import { METERING_POINT_FILTER_FORM } from '../../constants/formConsumptionPointFilter';
import { formValueSelector } from '../../reducers/reactFinalFormReducer';

const _searchConsumptionPoints = createAsyncPagingAction(
  CONSUMPTION_POINT_LIST_FETCH,
  consumptionPointListSearch,
  normalizeHelper([consumptionPointSchema])
);

const filterFormSelector = formValueSelector(METERING_POINT_FILTER_FORM);

export const searchConsumptionPoints = createAsyncActionStoreWrapper(
  _searchConsumptionPoints,
  filterFormSelector,
  getConsumptionPointList
);
